<script setup lang="ts">
import OmniDialog from "@/components/omni/OmniDialog.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { DialogSize } from "@/constants/dialog";
import { useAppStore } from "@/store/app.store";
import { useChat } from "@/composables/useChat";
import type { ChatStateThread } from "@/store/chat.store";

const props = withDefaults(
  defineProps<{
    thread: ChatStateThread;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const { t } = useI18n();
const appStore = useAppStore();
const { updateThread } = useChat();

const dialogVisible = ref(false);

async function askClaimThread() {
  if (props.thread.dispatcherId && props.thread.dispatcherId !== appStore.dispatcher?.id && !props.thread.resolved) {
    dialogVisible.value = true;
  } else {
    await updateThread(props.thread, { dispatcherId: appStore.dispatcher?.id ?? undefined, resolved: false });
  }
}

async function reClaimThread() {
  await updateThread(props.thread, { dispatcherId: appStore.dispatcher?.id ?? undefined, resolved: false });
  dialogVisible.value = false;
}
</script>

<template>
  <v-btn
    v-if="thread.dispatcherId !== appStore.dispatcher?.id || thread.resolved"
    :disabled="disabled"
    class="mr-2"
    color="primary"
    size="small"
    variant="outlined"
    @click="askClaimThread"
  >
    <v-icon class="mr-1"> mdi-account-plus-outline</v-icon>
    <span class="font-weight-600 text-uppercase text-primary">
      {{ t("dispatchers.claim") }}
    </span>
  </v-btn>

  <omni-dialog
    v-model="dialogVisible"
    primary-action-label="Claim"
    :size="DialogSize.small"
    title="Pay attention!"
    @primary-action:click="reClaimThread"
  >
    <div class="text-body-2 text-left text-grey text-grey-darken-1">
      If you want to claim this chat from
      <span v-if="thread.dispatcher">{{ thread.dispatcher.name }}</span>
      please press “Claim”!
    </div>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
